<template>
    <div>直接跳转到后台页面</div>
</template>


<script>
export default {
    data() { return {} },
    mounted() {

    }
}
</script>


<style scoped>
</style>


// WEBPACK FOOTER //
// jobContent.vue?485aa4a8